export default __webpack_public_path__ + "static/media/070_boost.vp9.f30108aa.webm";